<!-- 个人中心 > 首页 -->
<template>
  <div class="userCenterHome">
    <div class="companyInfo" >
      <commonHeader :title="'企业信息'" :small="true"></commonHeader>
      <div class="imgDiv">
        <img :src="companyInfo.logoImg ? this.$winpowUrl + companyInfo.logoImg : defaultImg" alt="">
      </div>
      <div class="companyDetail">
        <div class="detail">
          <img src="../../../assets/img/personalCenter/companyName.png" alt="">公司名称：{{ companyInfo.companyName }}
        </div>
        <div class="detail">
          <img src="../../../assets/img/personalCenter/socialCreditCode.png" alt="">信用代码：{{ companyInfo.socialCreditCode }}
        </div>
        <div class="detail">
          <img src="../../../assets/img/personalCenter/contactName.png" alt="">联&nbsp;&nbsp;系&nbsp;人：{{ companyInfo.contactName }}
        </div>
        <div class="detail">
          <img src="../../../assets/img/personalCenter/contactPhone.png" alt="">联系电话：{{ companyInfo.contactPhone }}
        </div>
      </div>
    </div>
    <div class="activity">
      <commonHeader :title="'待参加活动'" :small="true"></commonHeader>
      <userCenterTable
        :isGray="true"
        :isShowLoading="isShowLoading"
        :tableData="activityList.length > 0 ? activityList.slice((pageNumber - 1) * pageSize, pageNumber * pageSize) : []"
        :totalCount="activityList.length"
        :pageSize="pageSize"
        :pageNumber="pageNumber"
        :field-data="fieldData"
        @handleCurrentChange="handleCurrentChange"
      >
      </userCenterTable>
    </div>
    <div class="message">
      <commonHeader :title="'重要通知'" :small="true"></commonHeader>
      <ul class="message-item">
        <li v-for="(item, index) in messageList" :key="index">
          <div class="content" style="font-size: 16px;max-width: 620px;white-space: initial;line-height: 25px">
            <el-tooltip effect="light" placement="top" :content="item.messageTitle">
              <span @click="goDetail(item)">{{ item.messageTitle }}</span>
            </el-tooltip>
          </div>
          <div class="time">{{ item.inputTime }}</div>
        </li>
      </ul>
    </div>

    <el-dialog
        class="messageDetail"
        title="通知详情"
        width="900px"
        :visible.sync="messageDetailDialog"
        @close="refresh"
    >
      <div class="message-area">
        <div class="message-row">
          <div class="message-title">通知标题</div>
          <div class="message-content nowrap">{{ messageDetail.messageTitle }}</div>
        </div>
        <div class="message-row">
          <div class="message-title">通知时间</div>
          <div class="message-content">{{ messageDetail.inputTime }}</div>
        </div>
        <div class="message-row">
          <div class="message-title">通知内容</div>
          <div class="message-content" style="min-height: 200px">
            <p style="">{{ messageDetail.messageContent }}</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonHeader from '../componets/CommonHeader'
import userCenterTable from '../componets/UserCenterTable'
import { mapState } from 'vuex'
export default {
  name: 'UserCenterHome',
  components: { commonHeader, userCenterTable},
  props: {
    companyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    messageList: {
      type: Array
    },
    activityList: {
      type: Array
    }
  },
  computed: {
    ...mapState(['userData']),
    tableData() {
      if (this.companyInfo && this.companyInfo.length > 0) {
        return {}
      } else {
        return []
      }
    }
  },
  data() {
    return {
      messageDetail: '',
      messageDetailDialog: false,
      isShowLoading: false,
      totalCount: 0,
      pageSize: 4,
      pageNumber: 1,
      defaultImg: require('../../../assets/img/personalCenter/enterpriseLogo.png'),
      fieldData: [
        {
          field: 'activityTitle',
          label: '活动名称',
          width: '280',
          type: 'text'
        },
        {
          field: 'userName',
          label: '报名人',
          width: '80',
          type: 'text'
        },
        {
          field: 'cellPhone',
          label: '报名电话',
          width: '150',
          type: 'text'
        },
        {
          field: 'duty',
          label: '职务',
          width: '80',
          type: 'text'
        },
        {
          field: 'startTime',
          label: '开始时间',
          width: '180',
          type: 'text'
        }
      ]
    }
  },
  created() {
  },
  methods: {
    refresh() {
      this.$emit('getNoRead')
    },
    handleCurrentChange(val) {
      this.pageNumber = val
    },
    goDetail(data) {
      this.$get('/front/userCenter/messageInfo', data.pkid).then(() => {
      })
      this.messageDetail = data
      this.messageDetailDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.userCenterHome {
  .companyInfo,.activity,.message {
    background: #FFFFFF;
    border-radius: 10px;
    padding-left: 30px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .companyInfo {
    width: 890px;
    height: 283px;
    position: relative;
    .imgDiv {
      position: absolute;
      top: 94px;
      left: 30px;
      width: 138px;
      height: 138px;
      background: #FFFFFF;
      border: 1px solid #CCCCCC;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .companyDetail {
      position: absolute;
      top: 80px;
      left: 196px;
      width: 664px;
      .detail {
        width: 100%;
        height: 30px;
        line-height: 30px;
        margin-bottom: 18px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        img {
          display: inline-block;
          width: 30px;
          height: 30px;
          vertical-align: top;
          margin-right: 10px;
        }
      }
    }
  }
  .activity {
    position: relative;
    width: 890px;
    height: 335px;
    margin-top: 10px;
  }
  .message {
    width: 890px;
    height: 176px;
    margin-top: 10px;
    .message-item {
      width: 100%;
      height: 110px;
      margin-top: 10px;
      padding-left: 20px;
      list-style-type: square;
      box-sizing: border-box;
      overflow-y: scroll;
      li {
        position: relative;
        margin-bottom: 15px;
        .content {
          width: 700px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: middle;
          cursor: default;
        }
        .time {
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          position: absolute;
          top: 0;
          right: 30px;
        }
      }
    }
  }
}
</style>
